'use client';

import Image from 'next/image';
import Link from 'next/link';
import { HiOutlineArrowUturnRight } from 'react-icons/hi2';
import { Parallax } from 'react-scroll-parallax';

export default function AboutSection() {
  return (
    <section className="bg-secondary-light lg:py-16">
      <div className="lg:grid lg:grid-cols-12 flex flex-col w-[80%] m-auto">
        <div className="flex flex-col lg:col-span-6 md:pt-32 pt-16 pb-32 relative gap-6 lg:items-start items-center">
          <div className="flex flex-col lg:items-start items-center">
            <h5 className="uppercase text-primary-300 font-semibold font-alice pb-3">
              Chi Sono
            </h5>
            <h3 className="text-4xl font-bold uppercase font-alice lg:text-start text-center text-primary-900">
              Formazione ed Esperienza
            </h3>
            <div className="border-t-5 border-primary-300 h-[1px] w-20"></div>
          </div>
          <p className="text-xl text-ctext/90 font-alice leading-text lg:w-[75%] w-[90%] lg:text-start text-center">
            Mi sono laureata nel 2019 in <strong>Fisioterapia</strong> presso
            l'università Federico II di Napoli, conseguendo successivamente in{' '}
            <strong>Master in Posturologia</strong> e la laurea magistrale in{' '}
            <strong>Scienze riabilitative delle professioni sanitarie.</strong>
            <br />
            <br />
            Da allora non ho mai smesso di formarmi, partecipando a diversi
            corsi di formazione, spaziando dalla{' '}
            <strong>rieducazione posturale</strong> alla{' '}
            <strong>fisioterapia dermatofunzionale</strong> e alla{' '}
            <strong>terapia strumentale</strong>.
          </p>
          <Link
            className="flex w-fit font-lato tracking-tighter font-bold text-xl justify-center bg-white hover:bg-secondary-light border-1 border-primary-900 transition-colors duration-300 text-primary-900 p-3 rounded-full shadow-lg flex-row items-end gap-2"
            href="/chi-sono">
            Il mio percorso completo
            <HiOutlineArrowUturnRight className="text-xl scale-y-[-1]" />
          </Link>
        </div>
        <div className="flex flex-row gap-6 lg:col-span-6 lg:pb-0 pb-16 relative">
          <Parallax className="flex flex-col" speed={5}>
            <Image
              src="/images/angela-formisano-fisioterapista-2.webp"
              alt="Fisioterapista Angela Formisano mentre esegue un trattamento"
              width={400}
              height={600}
              className="rounded-[100px] border border-primary-900"
            />
          </Parallax>
          <Parallax className="flex flex-col" speed={-5}>
            <Image
              src="/images/angela-formisano-fisioterapista-3.webp"
              alt="Fisioterapista Angela Formisano mentre esegue un trattamento"
              width={400}
              height={600}
              className="rounded-[100px] border border-primary-900"
            />
          </Parallax>
        </div>
      </div>
    </section>
  );
}
